import axios from './axios'
// getPlatformInfo
export const getPlatformInfo = (url, data) => {
  return axios.postFromDataRequest(url, data)
}


// WEBPACK FOOTER //
// ./src/request/app.js